import { render } from "./PropertyBlock.vue?vue&type=template&id=69527cc9"
import script from "./PropertyBlock.vue?vue&type=script&lang=js"
export * from "./PropertyBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__